import * as applicantFullname from './applicantFullname';
import * as mailingAddress from './mailingAddress';
import * as phoneAndEmail from './phoneAndEmail';
import identificationInformation from './identificationInformation';
import * as employmentStatus from './employmentStatus';
import * as employmentDetails from './employmentDetails';
import * as employmentFocus from './employmentFocus';
import * as salaryDetails from './salaryDetails';
import * as educationDetails from './educationDetails';
import * as trainingProviderSummary from './trainingProviderSummary';
import * as trainingProviderDetails from './trainingProviderDetails';
import * as trainingProviderStartDate from './trainingProviderStartDate';
import * as atLeast3Years from './atLeast3Years';
import * as directDeposit from './directDeposit';
import * as contactPreferences from './contactPreferences';

export {
  applicantFullname,
  mailingAddress,
  phoneAndEmail,
  identificationInformation,
  employmentStatus,
  employmentDetails,
  employmentFocus,
  salaryDetails,
  educationDetails,
  trainingProviderSummary,
  trainingProviderDetails,
  trainingProviderStartDate,
  atLeast3Years,
  directDeposit,
  contactPreferences,
};
